module.exports = __webpack_public_path__ + "assets/dcf7fc09cacf6f5be4695fcc7073b3d0.png";